module.exports = __webpack_public_path__ + "img/Security-amico.54219706.svg";